import { useMutation } from 'react-query';
import editRoom from '../requests/editRoom';

const useEditRoomMutation = (options) =>
  useMutation(({ formValues }) => editRoom(formValues), options);

export default useEditRoomMutation;
